import { render, staticRenderFns } from "./HaberTanimla.vue?vue&type=template&id=47502c89&scoped=true&"
import script from "./HaberTanimla.vue?vue&type=script&lang=js&"
export * from "./HaberTanimla.vue?vue&type=script&lang=js&"
import style0 from "./HaberTanimla.vue?vue&type=style&index=0&id=47502c89&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "47502c89",
  null
  
)

export default component.exports